import {axios} from '../helpers/axiosService/index'

const SESSION_KEY = 'session'
const getToken = () => {
    const store = window.sessionStorage.getItem(SESSION_KEY)
    return store ? JSON.parse(store).token : ''
}
const createHeaders = () => ({
    headers: { 'x-access-token': getToken() }
});

// always call SIT_URL for testing
// if (process.env.NODE_ENV !== 'production') {
    //const SIT_URL = 'https://contentsuite.derbysoft-test.com/content-manager'
    //axios.defaults.baseURL = SIT_URL
// }
const BASE_URL = process.env.REACT_APP_HOST || 'https://contentsuite.derbysoft-test.com/content-manager'
axios.defaults.baseURL = BASE_URL

export const get = async (url: string) => {
  try {
    const response = await axios.get(url, createHeaders())
    return response?.data
  } catch (error: any) {
    console.log(error)
    return error
  }
}

export const patch = async (url: string, data: object) => {
  try {
    const response = await axios.patch(url, data, createHeaders())
    return response?.data
  } catch (error: any) {
    console.log(error)
    return error
  }
}
export const put = async (url: string, data: object) => {
  try {
    const response = await axios.put(url, data, createHeaders())
    return response?.data
  } catch (error: any) {
    console.log(error)
    return error
  }
}

export const post = async (url: string, data: object) => {
  try {
    const response = await axios.post(url, data, createHeaders())
    return response?.data
  } catch (error: any) {
    console.log(error)
    return error
  }
}

// no data parameter in delete method of axios
export const del = async (url: string, data: object) => {
  try {
    const response = await axios.delete(url, { data, ...createHeaders() })
    return response?.data
  } catch (error: any) {
    console.log(error)
    return error
  }
}
